export default "__VITE_ASSET__CBNBTfpl__"